import crownPacificFineFoodsLogo from "/img/integration/crownpacificfinefoods.png"
import { EmailConfigPage } from "../email-config-page"

export function ConfigCrownPacificFineFoodsPage() {
  return (
    <EmailConfigPage
      logo={crownPacificFineFoodsLogo}
      logoAlt="Crown Pacific Fine Foods"
      integrationName="crownpacificfinefoods"
      displayName="Crown Pacific Fine Foods"
      connectPath="/setup/connect/crownpacificfinefoods"
    />
  )
}
